// extracted by mini-css-extract-plugin
module.exports = {"level":"Footer_level__1Klja","levelRight":"Footer_levelRight__1R6Hd"};